module.exports = __webpack_public_path__ + "static/media/level365-logo.4e87a1c1.png";